import { readSessionStorage, setSessionStorage } from '../../../../wwwroot/js/local-storage.js';

const VERITY_CACHE_KEY = 'ip_verity';

function sendGamSegments(data) {
    if (!data) {
        return;
    }

    const segments = data.segments;

    if (!segments) {
        return;
    }

    const segmentArray = segments.map(segment => String(segment.id));

    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(() => {
        window.googletag.pubads().setTargeting('segment_list', segmentArray);
    });

    console.log('Sent gam segments', segmentArray);
}

function getTodayDateString() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${now.getFullYear()}-${month}-${day}`;
}

function readVerityCache(ppid) {
    const cached = readSessionStorage(VERITY_CACHE_KEY);
    if (!cached) {
        return null;
    }

    try {
        const entry = JSON.parse(cached);
        if (entry.ppid !== ppid || entry.date !== getTodayDateString()) {
            return null;
        }

        return entry.data;
    } catch {
        return null;
    }
}

function writeVerityCache(ppid, data) {
    setSessionStorage(VERITY_CACHE_KEY, JSON.stringify({
        ppid,
        date: getTodayDateString(),
        data,
    }));
}

export async function loadVerity(ppid) {
    if (!ppid) {
        window.verity = null;
        return;
    }

    const cached = readVerityCache(ppid);
    
    if (cached) {
        window.verity = cached;
        sendGamSegments(cached);

        return;
    }

    try {
        const response = await fetch(`/api/user?ppid=${encodeURIComponent(ppid)}`);

        if (!response.ok) {
            window.verity = null;
            return;
        }

        const data = await response.json();
        
        writeVerityCache(ppid, data);
        sendGamSegments(data);

        window.verity = data;
    } catch (error) {
        console.error('Failed to load verity data', error);
        window.verity = null;
    }
}
